var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "24px",
    viewBox: "0 0 33 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A6F74693-17FA-44AA-9BB0-4343F7010769") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coach",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-up-1.1",
    transform: "translate(-1689.000000, -492.000000)",
    stroke: "#F22B5D",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(1192.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 302.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "icn_verified",
    points: "498.5 66.3518519 506.75 74.5 528.5 54.5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnVerified);
export default __webpack_public_path__ + "static/media/icn_verified.741c8e36bf84480369186aa928ae0811.svg";
export { ForwardRef as ReactComponent };